import { ref, reactive, onMounted, readonly } from "vue" // ref 추가 확인
import type { WidgetSettings } from "../types/widget"

export function useWidgetSettings() {
  const loaded = ref(false)

  // 기본 설정값 정의
  const _settings = reactive<WidgetSettings>({
    position: "bottom-right",
    promoText: "도움이 필요하면 말씀해 주세요",
  })

  // 설정 로드 함수
  const loadSettings = () => {
    try {
      // 전역 설정에서 먼저 로드
      if (window.wowpressWidgetConfig) {
        Object.assign(_settings, window.wowpressWidgetConfig)
        console.log("[useWidgetSettings] Loaded from global config:", window.wowpressWidgetConfig)
      }

      // URL 파라미터에서 설정 덮어쓰기 (테스트 및 디버깅 용도)
      const urlParams = new URLSearchParams(window.location.search)

      if (urlParams.has("position")) {
        _settings.position = (urlParams.get("position") as WidgetSettings["position"]) || _settings.position
      }
      if (urlParams.has("promoText")) {
        _settings.promoText = urlParams.get("promoText") || _settings.promoText
      }

      console.log("[useWidgetSettings] Final settings:", _settings)
    } catch (error) {
      console.error("[useWidgetSettings] 설정 로드 중 오류 발생:", error)
    } finally {
      loaded.value = true
    }
  }

  // 컴포넌트 마운트 시 설정 로드 실행
  onMounted(() => {
    if (typeof window !== "undefined") {
      loadSettings()
    }
  })

  // settings를 ref(readonly(...)) 형태로 반환
  return {
    settings: ref(readonly(_settings)), // ref()로 감싸기
    loaded: readonly(loaded), // loaded 상태도 readonly로 제공
  }
}
